import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 20"><path d="M4.49 6.15a.54.54 0 010 .75L1.55 10h10a.5.5 0 01.09 1h-10l2.94 3.1a.54.54 0 010 .75.48.48 0 01-.7 0L.25 11.12A.87.87 0 010 10.5a.82.82 0 01.25-.62l3.54-3.73a.48.48 0 01.7 0z" fill-rule="evenodd"/></svg>`;

export { symbol as default };
